import { Spinner } from "../../components/spinner/Spinner";
import { IconButton } from "../../components/IconButton/IconButton";
import { getAPIClient } from "../../apiClient";
import { fetchRecordsUntilUpdated } from "../../utils/polling";
import React from "react";
import { useAtom } from "jotai";
import { refreshingAtom } from "../../jotai/atoms";

export default function RefreshButton() {
  const [refreshing, setRefreshing] = useAtom(refreshingAtom);

  const refreshRecords = async () => {
    setRefreshing(true);
    await getAPIClient().refreshRecords();
    await fetchRecordsUntilUpdated();
    setRefreshing(false);
  };

  return (
    <>
      {refreshing ? (
        <Spinner />
      ) : (
        <>
          <IconButton
            icon="refresh"
            onClick={() => refreshRecords()}
            alt={"refresh results"}
            className="max-md:hidden"
          />
          <img
            src="/assets/images/arrows_rotate.svg"
            alt="FAQ"
            className="md:hidden w-[24px] h-[24px]"
            onClick={() => refreshRecords()}
          />
        </>
      )}
    </>
  );
}
